import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { ImagesProps } from './images.props';
import styles from './images.module.scss';
import { Carousel } from './carousel';
import { ScrollLock } from '../../packages';

/**
 * <Images />
 */
const Images = ({
  className,
  images,
  classNameSlider,
  isShowArrows
}: ImagesProps) => {
  // const sliderRef = useRef(null);

  // useEffect(() => {
  //   if (show) {
  //     ScrollLock.lock();
  //   } else {
  //     ScrollLock.unlock();
  //   }
  // }, [show]);

  return (
    <div className={classNames(styles.container, className)}>
      <div className={classNames(styles.content, className)}>
        <Carousel
          className={classNameSlider}
          showArrows={images?.length > 1 && isShowArrows}
          // dotsClass={styles.dots}
        >
          {images?.map((image, index) => (
            <div key={index}>
              <img
                src={image}
                alt=''
                style={{
                  width: 'auto',
                  margin: '0 auto',
                  maxHeight: '450px',
                  objectFit: 'contain'
                }}
              />
            </div>
          ))}
        </Carousel>
        {/* {isShowButtonFullScreen && (
          <div className={styles.expand_container}>
            <img
              src='/img/expand-icon.svg'
              className={styles.expand}
              width='16px'
              height='16px'
              alt='Expand'
            />
          </div>
        )} */}
      </div>
      {/* <div
        ref={sliderRef}
        className={classNames(styles['popup-hidden'], {
          [styles.popup]: show
        })}
      >
        <Carousel centerMode variableWidth className={styles.carousel}>
          {images?.map((image, index) => (
            <div key={index} className={styles.img_container}>
              <img className={styles.img} src={image} alt='' />
            </div>
          ))}
        </Carousel>
        <img
          src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSozU1iS9IyGYGuEoIQcicu9vf-InsejlDt1Q&usqp=CAUÏ'
          className={styles.close}
          onClick={onClose}
          alt=''
        />
      </div> */}
    </div>
  );
};

export { Images };
